export interface User {
  id: string;
  email: string;
  fullname?: string;
  name?: string;
  role?: string;
  designation?: string | { name?: string };
  userType?: string;
  isSuperAdmin?: boolean;
  permissions?: Record<string, boolean> | Array<{ [key: string]: boolean }> | { [key: string]: { [key: string]: boolean } };
}

// Helper function to check if a user is an admin
export const isAdmin = (user: User | null): boolean => {
  if (!user) return false;
  return user.role === 'ADMIN' || user.role === 'superAdmin' || user.designation === 'superAdmin';
}

export interface AuthState {
  user: User | null;
  token: string | null;
  loading: boolean;
  error: string | null;
  isAuthenticated: boolean | null;
  forgotPasswordSuccess: boolean;
  otpVerified: boolean;
  verificationToken: string | null;
  resetPasswordSuccess: boolean;
  userExists: boolean;
}

export interface LoginCredentials {
  email: string;
  password: string;
  role: string;
  rememberMe?: boolean;
}

export interface LoginResponse {
  success: boolean;
  data: {
    admin?: User;
    employee?: User;
  };
  token: string;
}

export interface ForgotPasswordCredentials {
  email: string;
  role: string;
}

export interface VerifyOTPCredentials {
  email: string;
  otp: string;
  role: string;
}

export interface ResetPasswordCredentials {
  token: string;
  password: string;
  role: string;
}

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
  userExists?: boolean;
}

export interface VerifyOTPResponse {
  success: boolean;
  message: string;
  token: string;
}

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
}
